/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `phase1_accounts` - Faza 1 — konta
 * * `phase2_entity` - Faza 2 — encja
 * * `done` - Zakończono
 */
export type BulkPhaseEnum = typeof BulkPhaseEnum[keyof typeof BulkPhaseEnum];


export const BulkPhaseEnum = {
  phase1_accounts: 'phase1_accounts',
  phase2_entity: 'phase2_entity',
  done: 'done',
} as const;
